import get from 'lodash/get'
import { push as newRelicPush } from '../../browser/new-relic/index'
import { setRoute as setRouteNewRelic } from '../../new-relic-transaction/index'

export const BI_NEW_RELIC_ACTION_NAME = 'BIEvent'

/**
 * Set the current route in NewRelic
 * @param {Object} location A location object
 * @param {Map} [auth] The authentication state
 */
export function setNewRelicRoute (location, auth, extras = {}) {
  newRelicPush((newrelic) => {
    setRouteNewRelic({
      query: get(location, 'query', {}),
      pathname: get(location, 'pathname', ''),
      auth,
      newrelic,
      hydrateHit: extras.hydrateHit,
      contentType: extras.contentType,
      spaNav: extras.spaNav,
      fullplayer: extras.fullplayer,
    })
  })
}

/**
 * Set a page action in NewRelic
 * @param {String} name The action name
 * @param {Object} [data] Attributes for the action
 */
export function addNewRelicAction (name, data) {
  newRelicPush((newrelic) => {
    newrelic.addPageAction(name, data)
  })
}

export const SPA_PAGE_READY_ACTION = 'SpaPageReady'
